const mutations = {
  TOGGLE_EXCLUDE_ITEMS: (state) => {
    state.enableExcludeItems = !state.enableExcludeItems;
  },
  ITEM_TO_EXCLUDE: (state, { id, value }) => {
    if (value === true) {
      if (!state.excludedItems.includes(id)) {
        state.excludedItems.push(id);
      }
    } else if (state.excludedItems.includes(id)) {
      state.excludedItems = state.excludedItems.filter((l) => l !== id);
    }
  },
  SET_REPORT_TYPE: (state, value) => {
    state.reportType = value;
  },

  SET_REPORT_VIEW: (state, data) => {
    state.reportView = data;
  },

  SET_EXCLUDED_ITEMS: (state, data) => {
    state.excludedItems = data;
  },

  SET_GALLERY_IMAGES: (state, data) => {
    state.galleryImages = data;
  },

  SET_GALLERY_START_INDEX: (state, data) => {
    state.gallaryStartIndex = data;
  },

  SET_SELECTED_PHASE_ID: (state, phaseId) => {
    state.selectedPhaseId = phaseId;
  },
};

export default mutations;
